<template>
  <v-container fluid class="pa-0 ma-0" :style="'height: ' + height" ref="container" @mouseleave="endDragging">
    <v-row no-gutters style="position:relative; height: inherit;" @mouseup="endDragging">
      <v-col v-if="!hideCol1" :style="[!hideCol2 ? { maxWidth: `${value}%`, minWidth: `${value}%` } : 'maxWidth: 100%', 'position: relative;']" style="overflow-y: auto; height: inherit;" ref="col1" >
        <slot name="col1">
          Col 1 content
        </slot>
      </v-col>
      <div v-if="!hideCol1 && !hideCol2" class="divider" :class="!draggingDivider || 'active'"
        :style="{ left: `${value}%`, zIndex:10 }" @mousedown.prevent="startDragging" @mouseup="endDragging">
      </div>
      <v-col v-if="!hideCol2" :style="{ width: `${100 - value}%` }" style="position: relative; overflow-y: auto; height: inherit;" >
        <slot name="col2">
          Col 2 content
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

export default {
  name: "DraggableDividedLayout",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: [Number, String],
    fillHeight: Boolean,
    maxValue: Number,
    minValue: Number,
    hideCol1: Boolean,
    hideCol2: Boolean,
    height: {
      type: String,
      default: "inherit !important;",
    }
  },
  components: {},
  mixins: [],

  data() {
    return {
      offsetX: 0,
      outputValue: this.value,
      draggingDivider: false,
    };
  },

  mounted() {
  },

  methods: {
    handleDragging(e) {
      this.draggingDivider = true;
      const container = this.$refs.container.getBoundingClientRect();
      var percentage = ((e.pageX - (this.offsetX+2)) / (container.width)) * 100; //TODO: boost accuracy
      if (percentage < this.minValue) {
        percentage = this.minValue;
      }
      if (percentage > this.maxValue) {
        percentage = this.maxValue;
      }

      this.outputValue = percentage.toFixed(2)
      e.stopPropagation();
    },
    startDragging(e) {
      const boundingRect = this.$refs.container.getBoundingClientRect();
      this.offsetX = boundingRect.x;
      document.addEventListener('mousemove', this.handleDragging)
      e.stopPropagation()
    },
    endDragging() {
      const col1 = this.$refs.col1?.getBoundingClientRect();
      const container = this.$refs.container.getBoundingClientRect();
      const col1widthPercentage = ((col1?.width || 0 ) / container.width) * 100;
      if (col1widthPercentage < this.value) {
        this.outputValue = col1widthPercentage
      }

      document.removeEventListener('mousemove', this.handleDragging)
      this.draggingDivider = false;
    },
  },

  computed: {},

  watch: {
    outputValue(val) {
      if (val > this.minValue && val < this.maxValue) {
        this.$emit('change', val);
      }
    }
  },
};
</script>


<style lang='scss'>
.divider {
  height: 100%;
  width: 4px;
  background: #e5e5e8;
  transform: translateX(-2px);
  position: absolute;
  top: 0;
  z-index: 5;
  cursor: ew-resize;
}

.divider:hover,
.divider.active {
  background: var(--v-tertiary-base);
}
</style>